import React, { useState, useEffect, useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

import { CustomerContext } from '../../../contexts/customer-context';

import SpinnerContainer from '../../../component-library/spinner-container';
import Tile from '../../../component-library/tile';

const Pricing = () => {
	const {
		search: {
			dimensions: dimensionData,
		} = {},
	} = useContext(CustomerContext);
	const { data, uiMenuConfig } = useOutletContext();
	const [loading, setLoading] = useState(true);
	const [pricingData, setPricingData] = useState([]);

	const getData = () => {
		const newPricingData = dimensionData.find(item => item.code === 'pricingplans').values;
		const newPricingArray = [];

		if (newPricingData.length) {
			newPricingData.forEach(entry => {
				const pricingPlan = {
					...JSON.parse(entry.visualStyle),
					code: entry.code,
					name: entry.name,
				};
				newPricingArray.push(pricingPlan);
			});
		}

		setPricingData(newPricingArray);
		setLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.pricing?.label || 'Pricing'}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				<div className="pricing__grid margin-bottom-24">
					{pricingData?.length && data?.pricingplans.length ? (
						pricingData.map((plan, index) => (
							data.pricingplans.includes(plan.code) && (
								// eslint-disable-next-line react/no-array-index-key
								<Tile key={index}>
									<div className="pricing__card-container">
										<div className="pricing__card-heading text-capitalize">
											{plan.name}
										</div>
										<div className="pricing__card-value">
											{plan.cost}
										</div>
										<div className="pricing__card-units text-capitalize">
											Per
											{' '}
											{plan.period}
										</div>
										<div className="pricing__card-quota">
											Quota:
											{' '}
											{plan.quota}
										</div>
										<div className="pricing__card-description">
											{plan.description}
										</div>
									</div>
								</Tile>
							)
						))
					) : (
						<p className="grey-text">
							No pricing plans available
						</p>
					)}
				</div>
			)}
		</>
	);
};

export default Pricing;
